import { isDowngrading, planTiers } from "@/react/helpers/planHelpers";
import { useBillingContext } from "./BillingContext";
import { BillingDetailsContainer } from "./BillingDetailsContainer";
import { IncludedFeatures } from "./IncludedFeatures";
import { NotIncludedFeatures } from "./NotIncludedFeatures";
import { PlanDetailsSkeleton } from "./PlanDetailsSkeleton";
import { PlanHeader } from "./PlanHeader";

export const PlanDetails = () => {
  const { currentPlan } = useBillingContext();

  if (!currentPlan) {
    return <PlanDetailsSkeleton />;
  }

  return (
    <BillingDetailsContainer>
      <div className="flex flex-col gap-4">
        <PlanHeader />
        <IncludedFeatures />
        {isDowngrading(planTiers.enterprise, currentPlan.tier) && (
          <NotIncludedFeatures />
        )}
      </div>
    </BillingDetailsContainer>
  );
};
